
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ATTR_UNITOFMEASURE, ATTR_PROPERTYGROUP, ATTR_PROPERTYGROUP_ID } from '../helpers/constants'

@Component({
  template: `
  <div>
    <div v-if='Object.getOwnPropertyNames(groupProperties).length === 0' class="article-section-be">
      <table class="product-specifications-table product-specifications-table--be">
        <tbody>
          <tr v-if="productTitle">
            <td class="gray3--text">{{ articleNameTitle }}</td>
            <td class="gray4--text">{{ productTitle }}</td>
          </tr>
          <tr v-if="this.variantSku">
            <td class="gray3--text">{{ articleNumberTitle }}</td>
            <td class="gray4--text">{{ this.variantSku }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-for='(value, key, index) in groupProperties' :key='key' class="article-section">
      <expand-item :title='sectionName(value[0])' :initial-open='index === 0'>
        <table class="product-specifications-table">
          <tbody>
          <tr v-for='(prop, index) in value' :key='index'>
            <td class="gray3--text">{{ prop.displayName }}</td>
            <td class="gray4--text">{{ propertyValue(prop) }}</td>
          </tr>
          </tbody>
        </table>
      </expand-item>
    </div>
  </div>
  `
})
export default class ProductSpecifications extends Vue {
  @Prop() properties!: any
  @Prop({ default: '' }) productTitle: string
  @Prop({ default: '' }) articleNameTitle: string
  @Prop({ default: '' }) articleNumberTitle: string
  @Prop() variantSku: any
  ignorePropertyIds: string[] = ["prop--210"]
  // Sections: 9 - Maattekening, 22 - Commerciële informatie
  ignoreSectionIds: string[] = ["9", "19", "22", "26", "27", "28", "29", "30", "31"]

  // Old version
  // get groupProperties(): any {
  //   const grouped = this.properties.filter((item: any) => !this.ignorePropertyIds.includes(item.id))
  //     .filter((item: any) => !this.ignoreSectionIds.includes(item.sectionId))
  //     .reduce((result: any, prop: any) => {
  //       const key: string = prop.sectionSortIndex

  //       if (key && prop.isMultivalue && prop.values.length > 0) {
  //         if (!result[key]) result[key] = []
  //         result[key].sort((a: any, b: any) => (a.sortIndex > b.sortIndex) ? 1 : -1).push(prop)
  //       }

  //       if (key && !prop.isMultivalue && prop.value) {
  //         if (!result[key]) result[key] = []
  //         result[key].sort((a: any, b: any) => (a.sortIndex > b.sortIndex) ? 1 : -1).push(prop)
  //       }
  //       return result
  //     }, {} as any)
  //   return grouped
  // }

  get groupProperties(): any {
    const grouped = this.properties.filter((item: any) => !this.ignorePropertyIds.includes(item.id))
      .filter((item: any) => {
        const groupId = item.attributes.filter((item: any) => item.name === ATTR_PROPERTYGROUP_ID)[0]?.value || '';
        return !this.ignoreSectionIds.includes(groupId)
      })
      .reduce((result: any, prop: any) => {
        const groupId = prop.attributes.filter((item: any) => item.name === ATTR_PROPERTYGROUP_ID)[0]?.value || '';
        const key: string = groupId

        if (key && prop.isMultivalue && prop.values.length > 0) {
          if (!result[key]) result[key] = []
          result[key].sort((a: any, b: any) => (a.displayOrder > b.displayOrder) ? 1 : -1).push(prop)
        }

        if (key && !prop.isMultivalue && prop.value) {
          if (!result[key]) result[key] = []
          result[key].sort((a: any, b: any) => (a.displayOrder > b.displayOrder) ? 1 : -1).push(prop)
        }
        return result
      }, {} as any)
    return grouped
  }

  sectionName(property: any): string {
    return property.attributes.filter((item: any) => item.name === ATTR_PROPERTYGROUP)[0]?.value || '';
  }

  propertyValue(prop: any): string {
    if (prop.isMultivalue && prop.values.length > 0) {
      return prop.values.toString()
    } else if (prop.isMultivalue && prop.values.length === 0) {
      if (prop.value) {
        return prop.value;
      } else {
        return "-"
      }
    }
    if (prop.valueType == 'Boolean' && (prop.value == 'True' || prop.value == 'False')) return this.$options?.filters?.t(`${prop.value.toLowerCase()}Label`)
    const unitValue = prop.attributes.filter((item: any) => item.name === ATTR_UNITOFMEASURE)[0]?.value || '';
    if (unitValue) return prop.value + ' ' + unitValue

    return prop.value
  }

}
